const ROUTE_PARAM_PATTERN = /:(\w+)(\?)?/g;

// Fills `:param` placeholders from the current URL; returns undefined if a required one is missing.
const resolveRoutePath = (routePath: string, params: Record<string, string | undefined>): string | undefined => {
    let isResolvable = true;
    const resolvedPath = routePath.replace(ROUTE_PARAM_PATTERN, (_match, name: string, optional?: string) => {
        const value = params[name];
        if (value) return encodeURIComponent(value);
        if (!optional) isResolvable = false;
        return '';
    });
    return isResolvable ? resolvedPath.replace(/\/{2,}/g, '/').replace(/\/$/, '') : undefined;
};

export const getBreadcrumbNavigationTarget = (
    realmName: string,
    routePath: string,
    params: Record<string, string | undefined> = {}
): string | undefined => {
    if (routePath === 'devicedetails/:id?' || routePath === 'orgmanagementdetails/:realmPrefix/:orgId') {
        return undefined;
    }
    const resolvedPath = resolveRoutePath(routePath, params);
    return resolvedPath === undefined ? undefined : `/${realmName}/${resolvedPath}`;
};

export const shouldUseBrowserBackForDeviceDetails = (pathname: string): boolean =>
    /^\/[^/]+\/devicedetails(?:\/[^/]+)?$/.test(pathname);
